var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPants(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64.559,27.726c-0.044-1.072-0.926-1.917-1.998-1.917H33.439c-1.072,0-1.954,0.846-1.999,1.917l-1.667,40.384 c-0.022,0.544,0.178,1.073,0.556,1.467c0.377,0.393,0.898,0.615,1.443,0.615h10.676c0.949,0,1.767-0.667,1.959-1.596L48,51.171 l3.593,17.425c0.191,0.929,1.01,1.596,1.959,1.596h10.677c0.545,0,1.066-0.223,1.443-0.615c0.377-0.394,0.577-0.923,0.555-1.468 L64.559,27.726z M55.182,66.191l-5.223-25.327c-0.191-0.929-1.01-1.596-1.959-1.596s-1.767,0.667-1.959,1.596l-5.223,25.327h-6.962 l1.502-36.383h25.283l1.503,36.383H55.182z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPants);
export default __webpack_public_path__ + "static/media/pants.682641966e8450e8d315e6ec5a8adb97.svg";
export { ForwardRef as ReactComponent };